const { createElem } = require('../helperFunctions');
const getTiles = require('./getTiles');
class Sidebar {

    constructor(filterData) {
        this.filterData = filterData;
    }

    getFilterItemHtml(filterTitle, filterOpt) {

        const checkboxValue = filterOpt.value;
        const checkboxLabel = filterOpt.title;

        const item = createElem('li', { class: 'boxclass' });
        const input = createElem('input', { type: 'checkbox', id: checkboxLabel, name: filterTitle, value: checkboxValue });
        const label = createElem('label', { for: checkboxLabel }, checkboxLabel);

        item.appendChild(input);
        item.appendChild(label);

        return item;
    }

    getCategoryHtml(filterTitle, filterOptions) {
        console.log(filterTitle, 'kkk');
        
        const updatedilterTitle = filterTitle.replace(':', ' ');
        const dropdownLabel = filterTitle.replace("Browse by ", "").replace(":", "");
        const fieldset = createElem('fieldset', { class: 'filter-category', id: `onBrand__filter--${updatedilterTitle}` });
        const legend = createElem('legend', { class: 'onbrand__filter--title' }, updatedilterTitle);
        const categoryLabel = createElem('div', { id: 'onbrand__filter--select', class: 'onbrand__filter--select' });
        const spanTitle = createElem('span', { id: 'filter-title' }, `Select: ${dropdownLabel}`);
        const spanClose = createElem('span', { class: 'close_dropdown' });
        const svgDropdown = `<svg class='filter_dropdownSvg' xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path fill="#4A4A49" fill-rule="evenodd" d="M1.052.175L4.994 4.34 8.96.175c.523-.562 1.416.36.871.923l-4.465 4.75c-.196.203-.523.203-.697 0l-4.51-4.75c-.522-.562.37-1.485.894-.923z"></path></svg>`;
        const svgClose = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path fill="none" stroke="#4A4A49" stroke-linecap="round" stroke-width="2" d="M8.495 1.077L1.077 8.495m0-7.418l7.418 7.418"></path></svg>`;


        const filterList = createElem('ul', { class: 'onBrand__filter--dropdown', role: 'menu', 'aria-label': updatedilterTitle });
        spanClose.insertAdjacentHTML('beforeend', svgClose);
        categoryLabel.appendChild(spanTitle);
        // categoryLabel.appendChild(svgDropdown);
        categoryLabel.appendChild(spanClose);
        categoryLabel.insertAdjacentHTML('beforeend', svgDropdown);


        fieldset.appendChild(legend);
        fieldset.appendChild(categoryLabel);
        fieldset.appendChild(filterList);


        for (let i = 0; i < filterOptions.length; i++) {
            const filterItem = this.getFilterItemHtml(filterTitle, filterOptions[i]);
            filterList.appendChild(filterItem);
        }

        return fieldset;
    }


    getFormHtml() {
        const divWrapper = createElem('div', { id: 'onBrand__filter-wrapper' });
        const divelem = createElem('div', { class: 'filter-box' });
        const form = createElem('form', { id: 'onBrand__filter--form' });
        const resetDiv = createElem('div', { class: 'reset-button' });
        const resetBtn = createElem('button', { class: 'reset', type: 'button' }, 'Reset');

        resetDiv.appendChild(resetBtn);

        for (const filter in this.filterData) {
            const filterCategory = this.getCategoryHtml(filter, this.filterData[filter]);
            form.appendChild(filterCategory);
        }
        console.log(this.filterData, document.querySelectorAll('.collection-items-container li').length, 'filyger');

        form.appendChild(resetDiv);
        divelem.appendChild(form);
        divWrapper.appendChild(divelem);
        form.style.display = 'none';
        return divWrapper;
    }


    attatchEvents(handleCheckboxChange) {
        const checkboxInputs = [...document.querySelectorAll('#onBrand__filter--form input[type=checkbox]')];
        for (let i = 0; i < checkboxInputs.length; i++) {
            checkboxInputs[i].addEventListener('change', handleCheckboxChange);

        }

        return this;
    }



    init() {
        const target = document.querySelector('.page-aligner .description-block');
        if (!target) {
            throw new ReferenceError('Could not attach sidebar!');
        }

        document.querySelector('body').classList.add('onBrand__filter');
        target.insertAdjacentElement('afterend', this.getFormHtml());

        const checkboxInputs = [...document.querySelectorAll('#onBrand__filter--form input[type=checkbox]')];

        const divelem = document.querySelector('div .filter-box');
        const checkboxValue = Math.round(checkboxInputs.length / 4);
        if (checkboxInputs.length > 4) { //changes GWL OB-6891
            // divelem.style.height = "680px";
            if (checkboxValue > 2) {
                // eslint-disable-next-line no-mixed-operators
                // divelem.style.height = checkboxValue * 330 - 250 + 'px';
            }
        } else {
            // divelem.style.height = "330px";
        }
        if (checkboxInputs.length > 18) {
            divelem.style.overflowY = 'visible';
        }
        getTiles();
            
        return this;

    }

}

module.exports = Sidebar;


// WEBPACK FOOTER //
// ./scriptPartials/filter/Sidebar.js